import { SearchResults as CommonSearchResults } from 'common/components/entities/search-results'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { typedPageSelectors, usePage } from 'publisher/store/index'
import React, { useEffect, useState } from 'react'
import { useBlogSearch } from './hooks/use-blog-search'

interface SearchResultsProps {
  entity: SearchResultsInterface
}

export const SearchResults = ({ entity }: SearchResultsProps) => {
  const [isClient, setIsClient] = useState(false)
  const locale = usePage(typedPageSelectors.getLocale)
  const { searchResults } = useBlogSearch({
    limit: entity.maxItems,
  })

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <>
      {isClient && searchResults && (
        <StyleWrapper
          margin={entity.margin}
          mobileMargin={entity.mobileMargin}
          appearance={entity.appearance}
        >
          <CommonSearchResults
            locale={locale}
            paginationCurrent={searchResults.page}
            paginationTotal={searchResults.pages}
            resultsTotal={searchResults.total}
            data={searchResults.data}
            htmlAttrId={entity.htmlAttrId}
            padding={entity.padding}
            mobilePadding={entity.mobilePadding}
            card={entity.card}
            total={entity.total}
            title={entity.title}
            text={entity.text}
            date={entity.date}
            pagination={entity.pagination}
          />
        </StyleWrapper>
      )}
    </>
  )
}
